module.exports = __webpack_public_path__ + "img/ic_profile-blue.c1beb651.svg";